module.exports = {
  src: __webpack_public_path__ + "static/media/commercial_00038.ec9a8b12.jpg",
  width: 4992,
  height: 3328,
  bytes: 806506,
  type: "jpg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "static/media/commercial_00038.ec9a8b12.jpg";
};


//////////////////
// WEBPACK FOOTER
// ./src/core/images/galleries/commercial/commercial_00038.jpg
// module id = 305
// module chunks = 0